import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  scrap_details: [],
};

const getters = {
  allScrapDetails: (state) => state.scrap_details,
};

const actions = {
  async fetchScrapDetails({ commit }, params = {}) {
    try {
      commit("resetScrapDetails");
      const response = await axios.get("/scrap-detail", { params: prm(params) });
      commit("setScrapDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch scrap_details:", error);
    }
  },
  async createScrapDetail({ commit }, scrap_detail) {
    try {
      const response = await axios.post("/scrap-detail", scrap_detail);
      commit("addScrapDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create scrap_detail:", error);
      throw error;
    }
  },
  async fetchScrapDetailById(_, id) {
    try {
      const response = await axios.get(`/scrap-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch scrap_detail:", error);
      throw error;
    }
  },
  async updateScrapDetail({ commit }, scrap_detail) {
    try {
      const response = await axios.put(`/scrap-detail/${scrap_detail.id}`, scrap_detail);
      commit("updateScrapDetail", response.data);
    } catch (error) {
      console.error("Failed to update scrap_detail:", error);
      throw error;
    }
  },
  async deleteScrapDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/scrap-detail/${id}`);
      commit("removeScrapDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete scrap_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setScrapDetails(state, scrap_details) {
    state.scrap_details = scrap_details.data; // Ensure this matches your API's response structure
  },
  addScrapDetail(state, scrap_detail) {
    state.scrap_details.push(scrap_detail);
  },
  updateScrapDetail(state, updatedScrapDetail) {
    const index = state.scrap_details.findIndex(
      (scrap_detail) => scrap_detail.id === updatedScrapDetail.id
    );
    if (index !== -1) {
      state.scrap_details.splice(index, 1, updatedScrapDetail);
    }
  },
  removeScrapDetail(state, id) {
    state.scrap_details = state.scrap_details.filter(
      (scrap_detail) => scrap_detail.id !== id
    );
  },
  resetScrapDetails(state) {
    state.scrap_details = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
